/**
 * Human-readable label for report download buttons based on export language mode.
 */
export function getExportDownloadLanguageLabel(exportLanguageMode, sourceLabel, targetLabel) {
  switch (exportLanguageMode) {
    case 'analyst_only':
      return sourceLabel || 'Analyst language';
    case 'side_by_side':
      if (sourceLabel && targetLabel) return `${sourceLabel} / ${targetLabel}`;
      return 'Bilingual';
    case 'target_only':
    default:
      return targetLabel || 'Client language';
  }
}
